import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from "@angular/core";
import { GetConfigUseCase } from "../core/config/get-config.use-case";
import { ILobbyConfig } from "../core/config/interfaces";

@Component({
    selector: "game-limits",
    templateUrl: "./game-limits.component.html",
    styleUrls: ["./game-limits.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class GameLimitsComponent implements OnInit {
    protected data: {
        minBet: number;
        maxBet: number;
        maxWinAmount: number;
        maxMultiplier: number;
    } = {
        minBet: 0,
        maxBet: 0,
        maxWinAmount: 0,
        maxMultiplier: 0
    };

    constructor(private cdr: ChangeDetectorRef,
                private getConfigUseCase: GetConfigUseCase) {
        this.cdr.detach();
    }

    async ngOnInit(): Promise<void> {
        try {
            const config: ILobbyConfig | undefined = await this.getConfigUseCase.execute();
            this.data = {
                minBet: config?.minBet ?? 0,
                maxBet: config?.maxBet ?? 0,
                maxWinAmount: config?.maxWinAmount ?? 0,
                maxMultiplier: config?.maxMultiplier ?? 20000
            }
            this.cdr.detectChanges();
        } catch (e) {
            console.error(e);
        }
    }

}
